import { Signal, TemplateRef } from '@angular/core';

export interface SimpleTableColumnModel<T = any> {
  key: string;
  title: string;
  subTitle?: string;
  link?: boolean;
  sortDisabled?: boolean;
  sortKey?: string;
  class?: string;
  titleClass?: string;
  headerTooltip?: string;
  value?: (row: T) => string | number;
  tooltip?: (row: T) => string;
  template?: TemplateRef<any> | Signal<TemplateRef<any>> | null;
}

export interface SimpleTableActionModel<T = any> {
  id: string;
  icon?: string;
  label?: (data?: T) => string;
  class?: string;
  svgIcon?: boolean;
  /** Per-row visibility; omit to always show. `disableActions` greys a row out instead. */
  visible?: (row: T) => boolean;
}

export interface RowActionsConfig {
  menuRowActions?: boolean;
  menuRowActionsIcon?: string;
  svgIcon?: boolean;
}

export interface SimpleTableConfig {
  columnDefList: SimpleTableColumnModel[];
  displayedColumns: string[];
  rowActions?: SimpleTableActionModel[];
  disableActions?: (row: any) => boolean;
  rowActionsConfig?: RowActionsConfig;
  serverSidePagination?: boolean;
  isSortable?: boolean;
  hasPaginator?: boolean;
  hasSearchbox?: boolean;
  searchboxStyles?: string;
  hasCustomSearch?: boolean;
  filterPredicate?: (data: any, filter: string) => boolean;
  isSelectable?: boolean;
  selectAllOnInit?: boolean;
  totalTableStyles?: string;
  tableStyles?: string | Signal<string>;
  isCollapsible?: boolean;
  templateExpandible?: Signal<TemplateRef<any> | undefined>;
  hasInfiniteScroll: boolean;
  stickyHeader: boolean;
  title?: string;
  autoTable?: boolean;
  titleClass?: string;
  highlightRowOnClick?: boolean;
  highlightRowOnHover?: boolean;
  cellPointerOnRowClick?: boolean;
  zebraStriping?: boolean;
  id?: string;
  deleteOption?: boolean;
  changeColumnOption?: boolean;
  dragAndDrop?: boolean;
  // this option need id to be set
  columnFilter?: boolean;
  allowMultipleExpandedRows?: boolean;
  idPath?: string;
  handleCorruptedData?: boolean;
  corruptedPath?: string;
}

export interface TableFilters {
  paginator?: { length: number; pageIndex: number; pageSize: number };
  searchValue?: string;
  sort?: TableSort;
}

export interface TableSort {
  active: string;
  override?: string;
  direction: 'asc' | 'desc' | '';
}

export interface TableActions {
  val: any;
  type: string;
  filters: TableFilters;
  index: number;
}

export const createSimpleTableConfig = (): SimpleTableConfig => ({
  rowActions: [],
  columnDefList: [],
  displayedColumns: [],
  serverSidePagination: false,
  hasSearchbox: false,
  hasCustomSearch: false,
  hasPaginator: true,
  isSortable: true,
  isSelectable: false,
  totalTableStyles: '',
  tableStyles: '',
  isCollapsible: false,
  hasInfiniteScroll: false,
  stickyHeader: false,
  title: '',
  highlightRowOnClick: false,
  highlightRowOnHover: true,
  cellPointerOnRowClick: false,
  id: '',
  deleteOption: false,
  changeColumnOption: false,
  columnFilter: true,
  allowMultipleExpandedRows: false,
  dragAndDrop: false,
});
